/* Generated File DO NOT EDIT. */
/* tslint:disable */
export type Maybe<T> = T | null;
export type InputMaybe<T> = Maybe<T>;
export type Exact<T extends { [key: string]: unknown }> = { [K in keyof T]: T[K] };
export type MakeOptional<T, K extends keyof T> = Omit<T, K> & { [SubKey in K]?: Maybe<T[SubKey]> };
export type MakeMaybe<T, K extends keyof T> = Omit<T, K> & { [SubKey in K]: Maybe<T[SubKey]> };
/** All built-in and custom scalars, mapped to their actual values */
export type Scalars = {
  ID: string;
  String: string;
  Boolean: boolean;
  Int: number;
  Float: number;
  DateTime: any;
  JSONObject: any;
  _Any: any;
  federation__FieldSet: any;
  link__Import: any;
};

export type Activity = {
  __typename?: 'Activity';
  _id: Scalars['ID'];
  createdAt: Scalars['DateTime'];
  deletedAt?: Maybe<Scalars['DateTime']>;
  description: Scalars['String'];
  domain: Domain;
  domainID: Scalars['String'];
  schedule: Array<DayAndPeriod>;
  studyId: Scalars['ID'];
  subgoal?: Maybe<Scalars['String']>;
  type: ActivityType;
  updatedAt: Scalars['DateTime'];
  userId: Scalars['String'];
  weekOf: Scalars['String'];
};

export type ActivityInput = {
  description: Scalars['String'];
  domainID: Scalars['String'];
  offset: Scalars['Int'];
  schedule: Array<DayAndPeriodInput>;
  subgoal?: InputMaybe<Scalars['String']>;
  type: ActivityType;
};

export type ActivityLog = {
  __typename?: 'ActivityLog';
  activityId: Scalars['String'];
  day: Scalars['String'];
  period: Scalars['String'];
};

export type ActivityLogInput = {
  activityId: Scalars['String'];
  completed: CompletionStatus;
  day: Scalars['String'];
  period: Scalars['String'];
};

/** The status of activity */
export enum ActivityStatus {
  Full = 'FULL',
  NotCompleted = 'NOT_COMPLETED',
  Partial = 'PARTIAL'
}

export type ActivitySuggestion = {
  __typename?: 'ActivitySuggestion';
  _id: Scalars['ID'];
  createdAt: Scalars['DateTime'];
  deletedAt?: Maybe<Scalars['DateTime']>;
  description: Scalars['String'];
  domainId: Scalars['String'];
  studyId: Scalars['ID'];
  updatedAt: Scalars['DateTime'];
};

/** The type of activity */
export enum ActivityType {
  Meaningful = 'MEANINGFUL',
  Pleasant = 'PLEASANT',
  Social = 'SOCIAL'
}

export type AuthInput = {
  email: Scalars['String'];
  password: Scalars['String'];
};

export type AuthResponse = {
  __typename?: 'AuthResponse';
  accessToken: Scalars['String'];
  refreshToken: Scalars['String'];
};

export enum Category {
  Motivated = 'MOTIVATED',
  None = 'NONE',
  Unmotivated = 'UNMOTIVATED'
}

export enum CompletionStatus {
  Completed = 'COMPLETED',
  NotCompleted = 'NOT_COMPLETED',
  PartiallyCompleted = 'PARTIALLY_COMPLETED'
}

export type DailyLog = {
  __typename?: 'DailyLog';
  _id: Scalars['ID'];
  activities: Array<DailyLogActivity>;
  createdAt: Scalars['DateTime'];
  date: Scalars['DateTime'];
  deletedAt?: Maybe<Scalars['DateTime']>;
  questions: Array<DailyLogQuestion>;
  studyId: Scalars['ID'];
  updatedAt: Scalars['DateTime'];
  userID: Scalars['String'];
};

export type DailyLogActivity = {
  __typename?: 'DailyLogActivity';
  activityID: Scalars['String'];
  status: ActivityStatus;
};

export type DailyLogActivityInput = {
  activityID: Scalars['String'];
  status: ActivityStatus;
};

export type DailyLogInput = {
  activities: Array<DailyLogActivityInput>;
  offset: Scalars['Int'];
  questions: Array<DailyLogQuestionInput>;
};

export type DailyLogQuestion = {
  __typename?: 'DailyLogQuestion';
  answer: Scalars['String'];
  questionID: Scalars['String'];
};

export type DailyLogQuestionInput = {
  answer: Scalars['String'];
  questionID: Scalars['String'];
};

export type DayAndPeriod = {
  __typename?: 'DayAndPeriod';
  completed: Array<CompletionStatus>;
  day: Scalars['String'];
  period: Array<Scalars['String']>;
};

export type DayAndPeriodInput = {
  day: Scalars['String'];
  period: Array<Scalars['String']>;
};

export type Domain = {
  __typename?: 'Domain';
  _id: Scalars['ID'];
  color?: Maybe<Scalars['String']>;
  createdAt: Scalars['DateTime'];
  deletedAt?: Maybe<Scalars['DateTime']>;
  iconUrl?: Maybe<Scalars['String']>;
  studyId: Scalars['ID'];
  subTitle?: Maybe<Scalars['String']>;
  timeText?: Maybe<Scalars['String']>;
  title: Scalars['String'];
  updatedAt: Scalars['DateTime'];
};

export type DropdownOption = {
  __typename?: 'DropdownOption';
  option: Scalars['String'];
};

export enum InputMethod {
  Date = 'Date',
  DropDown = 'DropDown',
  NegativeMood = 'NegativeMood',
  Number = 'Number',
  PositiveMood = 'PositiveMood',
  Radio = 'Radio',
  Slider = 'Slider',
  Text = 'Text'
}

export type Message = {
  __typename?: 'Message';
  _id: Scalars['ID'];
  body: Scalars['String'];
  category?: Maybe<Category>;
  createdAt: Scalars['DateTime'];
  dayNum: Scalars['Float'];
  deletedAt?: Maybe<Scalars['DateTime']>;
  hour?: Maybe<Scalars['Float']>;
  minutes?: Maybe<Scalars['Float']>;
  studyId: Scalars['ID'];
  time: Scalars['String'];
  title?: Maybe<Scalars['String']>;
  updatedAt: Scalars['DateTime'];
  weekNum: Scalars['Float'];
};

export type MotivationAnswer = {
  __typename?: 'MotivationAnswer';
  answers: Array<Scalars['String']>;
  questionId: Scalars['String'];
};

export type Mutation = {
  __typename?: 'Mutation';
  createActivity: Activity;
  createDailyLog: DailyLog;
  createWeeklyLog: WeeklyLog;
  login: AuthResponse;
  markNotificationAsRead: Scalars['Boolean'];
  markNotificationsAsRegistered: Array<Scalars['Boolean']>;
  refreshToken: AuthResponse;
  register: AuthResponse;
  switchStudy: AuthResponse;
  updateActivity: Activity;
  updateActivityStatus: Scalars['Boolean'];
  updateUser: User;
  updateUserMotivated: Array<QuestionAnswerDate>;
  updateUserPreference: Scalars['Boolean'];
  updateUserRegistrationPreferences: Scalars['Boolean'];
  verifyAuthenticationResponse: AuthResponse;
  verifyRegistrationResponse: Scalars['JSONObject'];
};

export type MutationCreateActivityArgs = {
  input: ActivityInput;
};

export type MutationCreateDailyLogArgs = {
  input: DailyLogInput;
};

export type MutationCreateWeeklyLogArgs = {
  input: WeeklyLogInput;
};

export type MutationLoginArgs = {
  input: AuthInput;
};

export type MutationMarkNotificationAsReadArgs = {
  notificationId: Scalars['String'];
};

export type MutationMarkNotificationsAsRegisteredArgs = {
  notificationIds: Array<Scalars['String']>;
};

export type MutationRefreshTokenArgs = {
  input: RefreshTokenInput;
};

export type MutationRegisterArgs = {
  input: RegisterInput;
};

export type MutationSwitchStudyArgs = {
  input: SwitchStudyInput;
};

export type MutationUpdateActivityArgs = {
  id: Scalars['String'];
  input: ActivityInput;
};

export type MutationUpdateActivityStatusArgs = {
  input: ActivityLogInput;
};

export type MutationUpdateUserArgs = {
  input: UserInput;
};

export type MutationUpdateUserMotivatedArgs = {
  input: Array<QuestionAnswerInput>;
};

export type MutationUpdateUserPreferenceArgs = {
  input: Array<PreferenceInput>;
};

export type MutationUpdateUserRegistrationPreferencesArgs = {
  id: Scalars['String'];
  input: Array<QuestionAnswerInput>;
};

export type MutationVerifyAuthenticationResponseArgs = {
  authResp: Scalars['JSONObject'];
  userId: Scalars['String'];
};

export type MutationVerifyRegistrationResponseArgs = {
  attResp: Scalars['JSONObject'];
};

export type Notification = {
  __typename?: 'Notification';
  _id: Scalars['ID'];
  activityId?: Maybe<Scalars['String']>;
  body?: Maybe<Scalars['String']>;
  createdAt?: Maybe<Scalars['DateTime']>;
  deletedAt?: Maybe<Scalars['DateTime']>;
  message?: Maybe<Message>;
  messageId?: Maybe<Scalars['String']>;
  readAt?: Maybe<Scalars['DateTime']>;
  registeredAt?: Maybe<Scalars['DateTime']>;
  scheduledAt?: Maybe<Scalars['DateTime']>;
  studyId: Scalars['String'];
  title?: Maybe<Scalars['String']>;
  type: NotificationType;
  updatedAt: Scalars['DateTime'];
  userId: Scalars['String'];
};

export enum NotificationType {
  Activity = 'ACTIVITY',
  DailyLog = 'DAILY_LOG',
  Message = 'MESSAGE',
  WeeklyLog = 'WEEKLY_LOG'
}

export type Preference = {
  __typename?: 'Preference';
  domainId: Scalars['String'];
  importance: Scalars['String'];
  time: Scalars['String'];
};

export type PreferenceInput = {
  domainId: Scalars['String'];
  importance: Scalars['String'];
  time: Scalars['String'];
};

export type Query = {
  __typename?: 'Query';
  _entities: Array<Maybe<_Entity>>;
  _service: _Service;
  activities: Array<Activity>;
  activity: Activity;
  adminAvailableStudies: Array<Study>;
  dailyLogActivities: Array<ActivityLog>;
  dailyLogDate: Scalars['String'];
  domain: Domain;
  domains: Array<Domain>;
  generateAuthenticationOptions: Scalars['JSONObject'];
  generateRegistrationOptions: Scalars['JSONObject'];
  getDailyAnswers: Array<QuestionAnswer>;
  getQuestionByID: Question;
  getQuestions: Array<Question>;
  getQuestionsByStudyId: Array<Question>;
  getUnreadCount: Scalars['Int'];
  getUsers: Array<User>;
  getWeeklyLogs: Array<WeeklyLog>;
  getWeeklyLogsAnswers: Array<QuestionAnswer>;
  health: Scalars['String'];
  historicalActivities: Array<Activity>;
  isFirstWeek: Scalars['Boolean'];
  isUserMotivated: Category;
  message: Message;
  needToAnswerDailyLog: Scalars['Boolean'];
  needToAnswerWeeklyLog: Scalars['Boolean'];
  needToCompleteRegistration: Scalars['Boolean'];
  needToScheduleAChallengingActivity: Scalars['Boolean'];
  needToScheduleActivity: Scalars['Boolean'];
  notification: Notification;
  notifications: Array<Notification>;
  previousActivities: Array<Activity>;
  questions: Array<Question>;
  resources: Array<Resource>;
  study: Study;
  suggestions: Array<ActivitySuggestion>;
  userDomains: Array<Domain>;
  weeklyLogDate: Scalars['String'];
};

export type Query_EntitiesArgs = {
  representations: Array<Scalars['_Any']>;
};

export type QueryActivitiesArgs = {
  includeFuture?: InputMaybe<Scalars['Boolean']>;
  offset: Scalars['Int'];
};

export type QueryActivityArgs = {
  id: Scalars['String'];
};

export type QueryDailyLogActivitiesArgs = {
  offset: Scalars['Int'];
};

export type QueryDailyLogDateArgs = {
  offset: Scalars['Int'];
};

export type QueryDomainArgs = {
  id: Scalars['String'];
};

export type QueryGenerateAuthenticationOptionsArgs = {
  userId: Scalars['String'];
};

export type QueryGetDailyAnswersArgs = {
  type?: InputMaybe<InputMethod>;
};

export type QueryGetQuestionByIdArgs = {
  id: Scalars['String'];
};

export type QueryGetQuestionsArgs = {
  studyID: Scalars['String'];
};

export type QueryGetQuestionsByStudyIdArgs = {
  studyId: Scalars['String'];
};

export type QueryGetUnreadCountArgs = {
  type?: InputMaybe<NotificationType>;
};

export type QueryMessageArgs = {
  id: Scalars['String'];
};

export type QueryNeedToAnswerDailyLogArgs = {
  offset: Scalars['Int'];
};

export type QueryNeedToAnswerWeeklyLogArgs = {
  offset: Scalars['Int'];
};

export type QueryNeedToScheduleAChallengingActivityArgs = {
  offset: Scalars['Int'];
};

export type QueryNeedToScheduleActivityArgs = {
  offset: Scalars['Int'];
};

export type QueryNotificationArgs = {
  id: Scalars['ID'];
};

export type QueryNotificationsArgs = {
  offset: Scalars['Int'];
  type?: InputMaybe<NotificationType>;
};

export type QueryPreviousActivitiesArgs = {
  offset: Scalars['Int'];
};

export type QueryQuestionsArgs = {
  type?: InputMaybe<QuestionType>;
};

export type QuerySuggestionsArgs = {
  domainId: Scalars['String'];
};

export type QueryWeeklyLogDateArgs = {
  offset: Scalars['Int'];
};

export type Question = {
  __typename?: 'Question';
  _id: Scalars['ID'];
  createdAt: Scalars['DateTime'];
  deletedAt?: Maybe<Scalars['DateTime']>;
  description?: Maybe<Scalars['String']>;
  dropdownOptions?: Maybe<Array<DropdownOption>>;
  icon?: Maybe<Scalars['String']>;
  inputMethod: InputMethod;
  maxLabel?: Maybe<Scalars['String']>;
  maxValue?: Maybe<Scalars['Float']>;
  minLabel?: Maybe<Scalars['String']>;
  minValue?: Maybe<Scalars['Float']>;
  studyId: Scalars['ID'];
  title: Scalars['String'];
  type: QuestionType;
  updatedAt: Scalars['DateTime'];
};

export type QuestionAnswer = {
  __typename?: 'QuestionAnswer';
  answeredAt?: Maybe<Scalars['DateTime']>;
  questionId: Scalars['String'];
  response: Scalars['String'];
};

export type QuestionAnswerDate = {
  __typename?: 'QuestionAnswerDate';
  answeredAt?: Maybe<Scalars['DateTime']>;
  date: Scalars['DateTime'];
  questionId: Scalars['String'];
  response: Scalars['String'];
};

export type QuestionAnswerInput = {
  questionId: Scalars['String'];
  response: Scalars['String'];
};

export enum QuestionType {
  DailyLog = 'DailyLog',
  Motivation = 'Motivation',
  Onboarding = 'Onboarding',
  WeeklyLog = 'WeeklyLog'
}

export type RefreshTokenInput = {
  refreshToken: Scalars['String'];
};

export type RegisterInput = {
  accessCode: Scalars['String'];
  email: Scalars['String'];
  password: Scalars['String'];
};

export type Resource = {
  __typename?: 'Resource';
  _id: Scalars['ID'];
  availability?: Maybe<Scalars['String']>;
  body: Scalars['String'];
  createdAt: Scalars['DateTime'];
  deletedAt?: Maybe<Scalars['DateTime']>;
  externalLink?: Maybe<Scalars['String']>;
  externalLinkText?: Maybe<Scalars['String']>;
  phoneNumber?: Maybe<Scalars['String']>;
  studyId: Scalars['ID'];
  title: Scalars['String'];
  type: Scalars['String'];
  updatedAt: Scalars['DateTime'];
  videoLink?: Maybe<Scalars['String']>;
};

export enum Role {
  Admin = 'ADMIN',
  SuperAdmin = 'SUPER_ADMIN',
  User = 'USER'
}

export type Study = {
  __typename?: 'Study';
  _id: Scalars['ID'];
  accessCode: Scalars['String'];
  additionalUsers?: Maybe<Array<Scalars['String']>>;
  allowSocialActivity: Scalars['Boolean'];
  createdAt: Scalars['DateTime'];
  deletedAt?: Maybe<Scalars['DateTime']>;
  maxNumberOfActivities: Scalars['Float'];
  motivationAnswers: Array<MotivationAnswer>;
  name: Scalars['String'];
  studyId: Scalars['ID'];
  thisProgramIsBased?: Maybe<Scalars['String']>;
  updatedAt: Scalars['DateTime'];
};

export type SwitchStudyInput = {
  studyId: Scalars['String'];
};

export type User = {
  __typename?: 'User';
  _id: Scalars['ID'];
  age: Scalars['String'];
  completedRegistration: Scalars['Boolean'];
  createdAt: Scalars['DateTime'];
  deletedAt?: Maybe<Scalars['DateTime']>;
  email: Scalars['String'];
  gender: Scalars['String'];
  motivated: Array<QuestionAnswerDate>;
  preferences: Array<Preference>;
  registrationAnswers: Array<QuestionAnswer>;
  role: Role;
  studyId: Scalars['String'];
  updatedAt: Scalars['DateTime'];
};

export type UserInput = {
  age?: InputMaybe<Scalars['String']>;
  email?: InputMaybe<Scalars['String']>;
  gender?: InputMaybe<Scalars['String']>;
  registrationAnswers?: InputMaybe<Array<QuestionAnswerInput>>;
};

export type WeeklyLog = {
  __typename?: 'WeeklyLog';
  _id: Scalars['String'];
  createdAt: Scalars['DateTime'];
  date: Scalars['DateTime'];
  deletedAt?: Maybe<Scalars['DateTime']>;
  questions: Array<WeeklyLogQuestion>;
  studyId: Scalars['ID'];
  updatedAt: Scalars['DateTime'];
  userID: Scalars['String'];
};

export type WeeklyLogInput = {
  offset: Scalars['Int'];
  questions: Array<WeeklyLogQuestionInput>;
};

export type WeeklyLogQuestion = {
  __typename?: 'WeeklyLogQuestion';
  answer: Scalars['String'];
  questionID: Scalars['String'];
};

export type WeeklyLogQuestionInput = {
  answer: Scalars['String'];
  questionID: Scalars['String'];
};

export type _Entity = DailyLog | Domain | Message | Notification | Question | Resource | Study | User | WeeklyLog;

export type _Service = {
  __typename?: '_Service';
  sdl?: Maybe<Scalars['String']>;
};

export enum Link__Purpose {
  /** `EXECUTION` features provide metadata necessary for operation execution. */
  Execution = 'EXECUTION',
  /** `SECURITY` features provide metadata necessary to securely resolve fields. */
  Security = 'SECURITY'
}
